import * as z from "zod";

export const unpublishSignupForm = {
  name: "unpublishSignupForm" as const,
  input: z.object({ formId: z.string() }),
  output: z.literal("success"),
};
